import React from 'react'
import { ParsedUrlQuery } from 'querystring'
import { ButtonSizeValue, IconGiftDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE } from '../i18n'

export interface Pen5108GiftNowCtaProps {
  location: string
  query: ParsedUrlQuery
  CTA: React.ComponentType<{
    href?: string
    className?: string
    children?: React.ReactNode
    size?: ButtonSizeValue
    fullWidth?: boolean
    trackProps?: {
      action?: string
      location: string
    }
  }>
}

// same gift button logic as web/apps/next/src/pages/gift/components/Hero/Hero.tsx
export const Pen5108GiftNowCta = ({
  CTA,
  query,
  location,
}: Pen5108GiftNowCtaProps) => {
  const { t } = useTranslation(GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE)

  return (
    <>
      <div className='d-none d-md-block'>
        <CTA
          href={paths.checkoutGift(query)}
          trackProps={{
            action: t('common.cta'),
            location,
          }}
          size='md'
        >
          <div className='d-flex align-items-center mc-px-8'>
            <IconGiftDefault size='sm' className='mc-mr-1' />
            {t('common.cta')}
          </div>
        </CTA>
      </div>
      <div className='d-block d-md-none'>
        <CTA
          href={paths.checkoutGift(query)}
          trackProps={{
            action: t('common.cta'),
            location,
          }}
          className='flex-gap-1'
          fullWidth
        >
          <IconGiftDefault size='sm' />
          {t('common.cta')}
        </CTA>
      </div>
    </>
  )
}
